import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.css']
})
export class DetailsComponent implements OnInit {

  details: {
    screenshot: string,
    title: string,
    about: string
  }[] = [
    {
      screenshot: "assets/screenshots/map.png",
      title: "All in one map with advanced search",
      about: "Search for all types of professionals, products in your vicinity. You can ask professionals to do tasks or buy anything and get delivered same day and without paying any prime membership or hidden charges"
    },
    {
      screenshot: "assets/screenshots/create-task.png",
      title: "If you want to get something done ? Create task instantly",
      about: "Dogo enales you to create tasks and pings the professionals in your vicinity. Once task is sent to professionals, you get multiple proposals from professionals and you can go ahead with anyone"
    },
    {
      screenshot: "assets/screenshots/chat.png",
      title: "Chat with professionals in realtime",
      about: "As when you accept a task proposal from any professional, you are able to chat with them along with trustee. You can exchange information about the task. Give it a try today"
    }
  ];

  constructor() { }

  ngOnInit(): void { }

}
